import React from 'react'
import PropType from 'prop-types'
import Button from '@material-ui/core/Button'

const BaseButton = ({
  children, className, disabled, fullWidth, variant, onClick, type,
}) => (
  <Button
    variant={variant}
    disabled={disabled}
    className={className}
    fullWidth={fullWidth}
    onClick={onClick}
    type={type}
  >
    { children }
  </Button>
)

BaseButton.defaultProps = {
  children: null,
  className: '',
  disabled: false,
  fullWidth: false,
  onClick: () => null,
  type: 'text',
  variant: 'default',
}

BaseButton.propTypes = {
  children: PropType.node,
  className: PropType.string,
  disabled: PropType.bool,
  fullWidth: PropType.bool,
  onClick: PropType.func,
  type: PropType.string,
  variant: PropType.string,
}

export default BaseButton
